"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setBlockedOrderAlertSettings = exports.getBlockedOrderAlertSettings = void 0;
const fetchInstance_1 = require("../../../utils/fetchInstance");
/**
* @summary Pro feature C settings — email me when a large order is blocked
*/
const getBlockedOrderAlertSettings = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/alerts/blocked-order`, method: 'get'
    });
};
exports.getBlockedOrderAlertSettings = getBlockedOrderAlertSettings;
/**
* @summary Update Pro feature C settings (Pro only)
*/
const setBlockedOrderAlertSettings = (setBlockedOrderAlertSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/alerts/blocked-order`, method: 'patch',
        headers: { 'Content-Type': 'application/json', },
        data: setBlockedOrderAlertSettingsDto
    });
};
exports.setBlockedOrderAlertSettings = setBlockedOrderAlertSettings;
